document.querySelectorAll(".content-type-faq .content h3").forEach(titleFaq => {
    titleFaq.addEventListener("click", function(){ 
        if(!hasClass(this.closest(".content"), "open")){
            if(document.querySelector(".content-type-faq .content.open") != null){
                document.querySelector(".content-type-faq .content.open").classList.remove("open");
            }
            this.closest(".content").classList.add("open");
        }else{
            this.closest(".content").classList.remove("open");
        }
    });
});


document.querySelector(".menu-assistance").style.top = document.querySelector(".content-left").offsetTop + "px";
 
var menuItem = document.querySelectorAll(".menu-assistance li span");
menuItem.forEach(menu => {
    menu.addEventListener("click", function(){
        if(!hasClass(this, "active")){ 
            var targetSection = this.getAttribute("data-section");
            goToSection(targetSection);
        }
    });
}); 

function goToSection(idSection){  
    if(document.querySelector(".menu-assistance li span.active") != null){
        document.querySelector(".menu-assistance li span.active").classList.remove("active");
    } 
    if(document.querySelector(".content-sections .sections.active") != null){
        document.querySelector(".content-sections .sections.active").classList.remove("active");
    }
    document.querySelector(".menu-assistance li span[data-section='" + idSection + "']").classList.add("active");
    document.querySelector(".content-sections .sections[data-section='" + idSection + "']").classList.add("active");
}

//init
if(getParams("section") && getParams("section") != "" && document.querySelector(".content-sections .sections[data-section='" + getParams("section") + "']") != null){
    goToSection(getParams("section"));
}else{
    var firstItemMenu = document.querySelectorAll(".menu-assistance li span")[0].getAttribute("data-section");
    goToSection(firstItemMenu);
}